// extracted by mini-css-extract-plugin
export default {"select-activity":"selectActivity_select-activity__Ltoj4","continue-btn":"selectActivity_continue-btn__WCIFg"};